import React from 'react';

const isPdf = (uri: string, fileName?: string | null): boolean => {
	const target = (fileName || uri || '').toLowerCase().split('?')[0];
	return target.endsWith('.pdf');
};

/**
 * Opens an attachment in a new browser tab when it is a PDF, instead of letting
 * the browser download it
 */
export const openAttachment = async (
	event: React.MouseEvent<HTMLElement>,
	uri: string,
	fileName?: string | null,
): Promise<void> => {
	if (!isPdf(uri, fileName)) {
		return;
	}

	event.preventDefault();

	try {
		const response = await fetch(uri);
		const blob = await response.blob();
		const pdfBlob =
			blob.type === 'application/pdf'
				? blob
				: new Blob([blob], {type: 'application/pdf'});
		const objectUrl = URL.createObjectURL(pdfBlob);
		window.open(objectUrl, '_blank', 'noopener,noreferrer');
		setTimeout(() => URL.revokeObjectURL(objectUrl), 60_000);
	} catch {
		window.open(uri, '_blank', 'noopener,noreferrer');
	}
};
